module.exports = __webpack_public_path__ + "media/images/bg-tab-3752ea92.gif";